module.exports = __webpack_public_path__ + "files/6d5e2c3ec283f7c5680d1e452a759ed3.png";